module.exports = __webpack_public_path__ + "img/4.3c51fe0f.png";